export default __webpack_public_path__ + "static/media/avatar_6_2.02548bf0.png";